import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import "./Annotations.scss";
import AnnotationsStore from "./AnnotationsStore";
import { formatTimeWithoutSeconds } from "../../../../shared/dateTimeUtils";
import className from "../../../../shared/className";
import _ from "lodash";

class Annotations extends Component {
  constructor(props) {
    super(props);
    this.store = new AnnotationsStore();
  }

  componentDidUpdate() {
    if (this.props.expanded) {
      if (this.selectedAnnotationDiv) {
        this.selectedAnnotationDiv.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
      }
    }
  }

  render() {
    return (
      <div className="annotations component">
        {this.props.model?.annotationGroups.map((group) => (
          <div className="group" key={group.title}>
            <div className="group-head">{group.title}</div>
            {group.annotations.map((annotation) => {
              const selected =
                _.get(
                  this.props.summaryStore.selectedAnnotation,
                  "annotationId",
                ) === annotation.annotationId;
              return (
                <div
                  {...className({
                    annotation: 1,
                    selected,
                  })}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.props.summaryStore.selectAnnotation(annotation);
                  }}
                  key={annotation.annotationId}
                  ref={(el) => {
                    if (selected) this.selectedAnnotationDiv = el;
                  }}
                >
                  <div className="time">
                    {formatTimeWithoutSeconds(annotation.recordTime)}
                  </div>
                  <div className="annotation-content">
                    {annotation.nurseName && (
                      <div className="nurse-name">{annotation.nurseName}</div>
                    )}
                    <div>{annotation.annotation}</div>
                  </div>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    );
  }
}

export default inject("store")(observer(Annotations));
